export default __webpack_public_path__ + "static/media/94eea8ec-9d98-4f6c-af76-c52a1f12f871_200x200.048f4c5d.png";